import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES,} from "./languages";

const getStoredLanguage = () =>
  localStorage.getItem("app_language") || DEFAULT_LANGUAGE;

const initialLanguage = getStoredLanguage();

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng:"en",
    supportedLngs: SUPPORTED_LANGUAGES.map(l => l.code),
    ns: ["translation"],
    defaultNS: "translation",

    backend: {
      loadPath: "/locales/{{lng}}.json",
    },

    preload: [initialLanguage],

    load: "currentOnly",
    cleanCode: true,

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },

    initImmediate: false,

    debug: false,
  });

export default i18n;
